import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import * as React from 'react'
import { colors, H260 } from '@components/shared'

type PropsType = {
  title: string
}
export default function SectionTitle (props: PropsType): React.ReactNode {
  return (<SectionTitleContainer className='SectionTitle'>
    <H260 color={colors.sand}>{props.title}</H260>
    <Hr size={1}/>
  </SectionTitleContainer>)
}

const SectionTitleContainer = styled.div<any>`
  margin-top: 70px;

  ${(props: any): any => config(props).media.lg`
    margin-top: 90px;
  `}
`
const Hr = styled.hr<any>`
  height: 1px;
  background-color:${colors.sand};
  border: none;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 30px;

  ${(props: any): any => config(props).media.sm`
    margin-bottom: 30px;
  `}

  ${(props: any): any => config(props).media.lg`
    margin-top: 20px;
    margin-bottom: 35px;
  `}

  ${(props: any): any => config(props).media.xl`
    margin-top: 23px;
    margin-bottom: 40px;
  `}
`
